import "./PanelBuildersUL508A.module.css";
import Header from "@/reusable_sections/Header";
import DirectAnswerBlock from "./sections/DirectAnswerBlock";
import ThePanelBuildersWorkflow from "./sections/ThePanelBuildersWorkflow";
import WhatAUL508APanelNeeds from "./sections/WhatAUL508APanelNeeds";
import ConsistencyAcrossBuilds from "./sections/ConsistencyAcrossBuilds";
import Ul508aMarkingCompliance from "./sections/Ul508aMarkingCompliance";
import HowToOrder from "./sections/HowToOrder";
import Faq from "./sections/Faq";
import ClosingCta from "./sections/ClosingCta";
import Footer from "@/reusable_sections/Footer";
export default function PanelBuildersUL508APage() {
  return <div>
      <Header />
      <DirectAnswerBlock />
      <ThePanelBuildersWorkflow />
      <WhatAUL508APanelNeeds />
      <ConsistencyAcrossBuilds />
      <Ul508aMarkingCompliance />
      <HowToOrder />
      <Faq />
      <ClosingCta />
      <Footer />
    </div>;
}